import { atom } from 'recoil';

// Error types enum
export const ERROR_TYPES = {
  LINE_AUTH: 'LINE_AUTH'
};

const flightPath = atom({
  key: 'flightPath',
  default: {
    isLoading: false,
    treatments: []
  }
});

export const retainerJourney = atom({
  key: 'retainer-journey',
  default: false
});

export const consentForm = atom({
  key: 'consent-form',
  default: false
});

export const appointments = atom({
  key: 'appointments',
  default: {
    pastAppointments: [],
    upcomingAppointments: [],
    scheduledAppointments: [],
    expectedAppointments: []
  }
});

export const focusedSetAppointment = atom({
  key: 'focusedSetAppointment',
  default: {
    selectedAppointmentCardId: ''
  }
});

export const smilePlanStatus = atom({
  key: 'smilePlanStatus',
  default: {
    smilePlanStatus: {}
  }
});

export const showRetainerFaqs = atom({
  key: 'showRetainerFaqs',
  default: false
});

export const currentMenuOption = atom({
  key: 'currentMenuOptionKey',
  default: ''
});

export const showRetainerIllFittingFormData = atom({
  key: 'showRetainerIllFittingFormData',
  default: false
});

export const error = atom({
  key: 'error',
  default: null
});

export default flightPath;
